import { render, staticRenderFns } from "./TextFieldComponent.vue?vue&type=template&id=2821b260&scoped=true&"
import script from "./TextFieldComponent.vue?vue&type=script&lang=js&"
export * from "./TextFieldComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldComponent.vue?vue&type=style&index=0&id=2821b260&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821b260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VTextField})
